// Single source of truth for Pula / Mavula company details.
export const COMPANY = {
  name: "Mavula Investment Ltd",            // brand / trading display name
  legalName: "MAVULAINVESTMENT LTD",        // exact Companies House registered name
  crn: "17368822",
  jurisdiction: "England & Wales",
  registeredOffice: "Lewis Building, 35 Bull Street, Birmingham, B4 6AF, United Kingdom",
};

// Public social profiles (verified/owned by Pula). Only add REAL, live URLs here —
// they render in the footer and feed the Organization schema `sameAs`.
export const SOCIALS = [
  { name: "Instagram", url: "https://www.instagram.com/pula.2026", handle: "@pula.2026" },
  { name: "LinkedIn", url: "https://www.linkedin.com/in/pula-love-a2a802434", handle: "LinkedIn" },
  { name: "Trustpilot", url: "https://www.trustpilot.com/review/pulalove.com", handle: "Trustpilot" },
];
